import { render, staticRenderFns } from "./Kusama.vue?vue&type=template&id=e5e7aaba&scoped=true&"
import script from "./Kusama.vue?vue&type=script&lang=js&"
export * from "./Kusama.vue?vue&type=script&lang=js&"
import style0 from "./Kusama.vue?vue&type=style&index=0&id=e5e7aaba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e7aaba",
  null
  
)

export default component.exports